import React from "react";
import SignOut from '../containers/SignOut';

export default (props) => (<SignOut {...props} />);

